export default {
  GET_FOOTER_DATA_REQUESTED: 'GET_FOOTER_DATA_REQUESTED',
  GET_FOOTER_DATA_FAILED: 'GET_FOOTER_DATA_FAILED',
  GET_FOOTER_DATA_SUCCEEDED: 'GET_FOOTER_DATA_SUCCEEDED',
};
